import GradeLessonPage from '../components/GradeLessonPage';

// Import all Precalculus topics
import { advancedFunctionsData } from './advanced-functions';
import { trigonometryData } from './trigonometry';
import { complexNumbersData } from './complex-numbers';
import { vectorsMatricesData } from './vectors-matrices';
import { conicSectionsData } from './conic-sections';
import { probabilityStatistics } from './probability-statistics';
import { limits } from './limits';

export default function PreCalcPage() {
  return (
    <GradeLessonPage
      grade="precalc"
      gradeLabel="Pre-Calculus"
      gradeColor="purple"
      topics={[
        advancedFunctionsData,
        trigonometryData,
        complexNumbersData,
        vectorsMatricesData,
        conicSectionsData,
        probabilityStatistics,
        limits
      ]}
      prevGrade={{ label: 'Grade 11', path: '/grade/11' }}
      nextGrade={null}
    />
  );
}
